import React, { Component } from 'react';
import axios from 'axios';
import Helping from '../../helpers/Helping';
import Notification from '../layout/Notification';
import Pagination from 'react-js-pagination';
import { MESSAGE, ROLE, ROUTE_ACCESS } from '../../config/index';
import { TEZOS_META_MASK, MATIC_META_MASK, META_MASK, STORE_WEBSITE, API_URL } from '../../config/urls';
import { GET_SETTING } from '../../config/routes';
import Service from '../../helpers/service';
import { setErrorFields, validateField } from '../../helpers/validationHelpers';
import { connect } from 'react-redux';
import { getAll, update, setItemCopiesError, destroy } from '../../services/item_copies.service';
import { setProfileError, addCurrentRoute } from '../../actions/profile_action';
import UpdateCopy from './Update';
import ReorderCopies from './Reorder';
import MoneyField from '../fields/moneyField';
import LoadingButton from '../fields/LoadingButton';
import Filter from "../layout/Filter";

const { DELETE, NOT_FOUND, EMPTY, RELEASE, UPDATE } = MESSAGE;
class List extends Component {
    selectRef = null;
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            url: API_URL.ADMIN_TRADING_API + 'item-copies',
            count: '',
            routeName: '',
            username: '',
            token_id: '',
            transaction_hash_slot_limit: '',
            transaction_hash_values: '',
            ids: '',
            release_transaction_hash: '',
            transaction_hash: '',
            error_message: '',
            error_type: '',
            isLoading: true,
            btnIsDisable: false,
            total: 0,
            activePage: 1,
            limit: 10,
            search: '',
            sorting: 'id',
            sort_type: 'DESC',
            is_order: false,
            openModal: false,
            edit_id: "",
            slideModal: false,
            blockchain: '',
            releasedFilter: '',
            enableSaleFilter: '',
            idFilter: '',
            codeFilter: '',
            nameFilter: '',
            owner_id: ''
        };

        this.handleValueChange = this.handleValueChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleLimitChange = this.handleLimitChange.bind(this);
        this.pageRefreshFunction = this.pageRefreshFunction.bind(this);
        this.sortBy = this.sortBy.bind(this);
    }

    setErrorOnApiCall = () => {
        setItemCopiesError(res => this.setState({ ...res }));
        setProfileError(res => this.setState({ ...res }));
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    componentDidMount() {
        const { pathname } = this.props.location;
        this.props.addCurrentRoute(this.props.profile, pathname);
        this.setErrorOnApiCall();

        this.setState({
            routeName: pathname
        });

        // if (this.props.isLoading == true && this.props.total < 1) {
        this.getItems();
        // }
    }

    getItems() {
        let search = this.state.search;
        this.props.getAll(
            this.state.activePage,
            this.state.limit,
            search.trim(),
            this.state.sorting,
            this.state.sort_type,
            this.state.blockchain,
            this.state.releasedFilter,
            this.state.enableSaleFilter,
            this.state.idFilter,
            this.state.nameFilter,
            this.state.codeFilter,
            this.state.owner_id
        );
    }

    pageRefreshFunction(e) {
        e.preventDefault();

        this.setState({
            search: "",
            activePage: 1,
            error_type: "",
            error_message: "",
            blockchain: "",
            releasedFilter: "",
            enableSaleFilter: "",
            idFilter: '',
            nameFilter: '',
            codeFilter: '',
            owner_id: ""
        },
            () => { this.getItems() });
    }

    deleteItem(e, object) {
        let self = this;

        if (window.confirm('Are you sure???')) {
            axios
                .delete(this.state.url + '/' + object.id, Helping.getConfig())
                .then(response => {
                    self.setState({
                        error_message: Helping.getMessageString(DELETE, 'Item Copies'),
                        error_type: 'success'
                    });

                    const items = Helping.removeItem(self.state.items, object.id);
                    self.setState({
                        items: items
                    });

                    document.getElementById('nprogress').style.display = 'none';
                })
                .catch(error => {
                    if (error.response) {
                        Helping.redirectToLogin(error);
                        return self.setState({
                            error_message: error.response.data.message,
                            error_type: 'danger'
                        });
                    }
                    return this.setState({
                        ...Helping.setNetworkRequestError(error, "nft copy deletion")
                    })
                });
        }
    }

    handlePageChange(pageNumber) {
        if (this.state.activePage === pageNumber) {
            return false;
        }

        this.setState({
            activePage: pageNumber,
            isLoading: true
        },
            () => this.getItems()
        );
    }

    handleLimitChange(itemsLimit) {
        if (this.state.limit === itemsLimit) {
            return false;
        }
        this.setState({
            limit: itemsLimit,
            activePage: 1,
            isLoading: true
        },
            () => this.getItems());
    }

    handleSearchChange(e) {
        let $this = this,
            searchValue = e.target.value.replace(/^\s+/g, '');

        if (this.state.search !== searchValue) {
            this.setState({
                search: searchValue,
                activePage: 1
            },
                () => {
                    if (searchValue.length > 0) {
                        $this.getItems();
                    }

                    if (searchValue.length === 0) {
                        $this.getItems();
                    }
                });
        }
    }

    handleInputChange = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });

        if (name === "transaction_hash") this.setState({ ...await validateField("string", name, value, "", 1) });
        if (name === "transaction_hash_values") this.setState({ ...await validateField("string", name, value, "", 1) });
        if (name === "transaction_hash_slot_limit") this.setState({ ...await validateField("string", name, value, "", 1) });
        if (name === "release_transaction_hash") this.setState({ ...await validateField("string", name, value, "", 1) });
        if (name === "username") this.setState({ ...await validateField("string", name, value, "", 1) });
        if (name === "token_id") this.setState({ ...await validateField('numeric', name, value, '', 1) });
        if (name === "ids") this.setState({ ...await validateField('string', name, value, '', 1) });
    }

    sortBy(key) {
        let $this = this;
        let sortType = this.state.sort_type;

        if (this.state.sort_type === 'ASC') {
            sortType = 'DESC';
        }

        if (this.state.sort_type === 'DESC') {
            sortType = 'ASC';
        }

        this.setState({
            sorting: key,
            activePage: 1,
            is_order: true,
            sort_type: sortType
        },
            () => $this.getItems());
    }

    refCallback = (name, val) => {
        this.selectRef = val;
    }

    checkEmptyReleasedFields = () => {
        const { ids, release_transaction_hash } = this.state;
        let formHasError = false;

        if (ids.length < 1) {
            let errorObject = setErrorFields("ids", Helping.getMessageString(EMPTY, "ids"));
            this.setState(errorObject);
            formHasError = true;
        }
        if (release_transaction_hash.length < 1) {
            let errorObject = setErrorFields("release_transaction_hash", Helping.getMessageString(EMPTY, "transaction hash"));
            this.setState(errorObject);
            formHasError = true;
        }

        return formHasError;
    }

    submitReleaseNftModal = (e) => {
        e.preventDefault();

        const { ids, release_transaction_hash } = this.state;
        const formHasError = this.checkEmptyReleasedFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return true;
        }

        this.setState({
            btnIsDisable: true
        })

        Service.postCall(API_URL.ADMIN_TRADING_API + GET_SETTING, {
            action: 'release-nfts',
            ids: Helping.convertCommaStringIntoArray(Helping.removeBracketsFromString(ids)),
            transaction_hash: release_transaction_hash
        })
            .then(response => {
                this.setState({
                    ids: '',
                    release_transaction_hash: '',
                    error_message: Helping.getMessageString(RELEASE, "nft copies"),
                    error_type: "success",
                    btnIsDisable: false,
                }, () => { this.closeModal(); this.scrollToTop(); });

            }).catch(error => {
                console.log({ error });

                if (error.response) {
                    Helping.redirectToLogin(error);
                    return this.setState({
                        error_message: error.response.data.message,
                        error_type: 'danger',
                        btnIsDisable: false
                    }, () => { this.closeModal(); this.scrollToTop(); });
                }
                return this.setState({
                    isLoading: false,
                    btnIsDisable: false,
                    ...Helping.setNetworkRequestError(error, "releasing nft copies")
                }, () => { this.closeModal(); this.scrollToTop(); })
            });
    }

    checkEmptyHashModal = () => {
        const { transaction_hash_slot_limit, transaction_hash_values } = this.state;
        let formHasError = false;

        if (transaction_hash_slot_limit.length < 1) {
            let errorObject = setErrorFields("transaction_hash_slot_limit", Helping.getMessageString(EMPTY, "transaction hash slot limit"));
            this.setState(errorObject);
            formHasError = true;
        }
        if (transaction_hash_values.length < 1) {
            let errorObject = setErrorFields("transaction_hash_values", Helping.getMessageString(EMPTY, "transaction hashes"));
            this.setState(errorObject);
            formHasError = true;
        }
        return formHasError;
    }

    submitSlotHashModal = (e) => {
        e.preventDefault();

        const { transaction_hash_slot_limit, transaction_hash_values } = this.state;
        const formHasError = this.checkEmptyHashModal();
        if (formHasError) {
            window.scrollToErrorFields();
            return true;
        }

        this.setState({
            btnIsDisable: true
        })

        Service.postCall(API_URL.ADMIN_TRADING_API + GET_SETTING, {
            action: 'update-reserved-slot',
            transaction_hash: Helping.convertCommaStringIntoArray(
                Helping.removeBracketsFromString(transaction_hash_values)
            ),
            limit: transaction_hash_slot_limit,
        })
            .then((response) => {
                this.setState(
                    {
                        ids: '',
                        release_transaction_hash: '',
                        error_message: Helping.getMessageString(UPDATE, 'nft slot hashes'),
                        error_type: 'success',
                        btnIsDisable: false,
                    },
                    () => { this.closeModal(); this.scrollToTop(); }
                );
            })
            .catch((error) => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    return this.setState(
                        {
                            error_message: error.response.data.message,
                            error_type: 'danger',
                            btnIsDisable: false,
                        },
                        () => { this.closeModal(); this.scrollToTop(); }
                    );
                }
                return this.setState(
                    {
                        isLoading: false,
                        btnIsDisable: false,
                        ...Helping.setNetworkRequestError(error, 'releasing nft copies'),
                    },
                    () => { this.closeModal(); this.scrollToTop(); }
                );
            });
    }

    getMetaMaskLink = (copy) => {
        if (copy.which_bc === "MATIC")
            return MATIC_META_MASK.LINK + copy.id;

        else if (copy.which_bc === "ETH")
            return META_MASK.LINK + copy.id;

        else if (copy.which_bc === "TEZOS")
            return TEZOS_META_MASK.LINK + copy.id;
    }

    openEditModal = (e, object) => {
        this.setState({ edit_id: object.id, slideModal: true });
    }

    closeModal = () => {
        window.$('#reorderCopiesModal').modal('hide');
        window.$('#nftSlotHash').modal('hide');
        window.$('#releaseNftCopies').modal('hide');
        window.$('#editNFTCopies').modal('hide');
        this.setState({
            openModal: false,
            slideModal: false,
            edit_id: "",
            error_transaction_hash_values_message: "",
            error_transaction_hash_slot_limit_message: "",
            error_ids_message: "",
            error_release_transaction_hash_message: ""
        })
    }

    filteredResults = (e) => {
        e.preventDefault();
        this.setState({
            activePage: 1
        }, () => this.getItems())
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    handleValueChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    componentWillUnmount() {
        this.props.destroy();
    }

    render() {
        let role_access = {}, isAdmin = false;
        const filtersArray = [this.props.owner_id, this.props.blockchain, this.props.enable_sale, this.props.is_released, this.props.idFilter, this.props.codeFilter, this.props.nameFilter],
            data = {
                inputs: [{
                    type: 'dropdown',
                    label: 'Blockchain',
                    name: 'blockchain',
                    defaultValue: this.state.blockchain,
                    placeholder: 'Select Blockchain...',
                    data: [{ "value": 'ETH', "name": 'ETH' }, { "value": 'MATIC', "name": 'MATIC' }, { "value": 'CARDANO', "name": 'CARDANO' }]
                }, {
                    type: 'dropdown',
                    label: 'On Sale',
                    name: 'enableSaleFilter',
                    defaultValue: this.state.enableSaleFilter,
                    placeholder: 'Select On Sale...',
                    data: [{ "name": 'TRUE', "value": 1 }, { "name": 'FALSE', "value": 0 }]
                }, {
                    type: 'dropdown',
                    label: 'Released/Unreleased',
                    name: 'releasedFilter',
                    defaultValue: this.state.releasedFilter,
                    placeholder: 'Select Released/Unreleased...',
                    data: [{ "name": 'Released', "value": 1 }, { "name": 'Unreleased', "value": 0 }]
                }, {
                    type: 'textInput',
                    label: 'Id',
                    name: 'idFilter',
                    defaultValue: this.state.idFilter
                }, {
                    type: 'textInput',
                    label: 'Code',
                    name: 'codeFilter',
                    defaultValue: this.state.codeFilter
                }, {
                    type: 'textInput',
                    label: 'Name',
                    name: 'nameFilter',
                    defaultValue: this.state.nameFilter
                }],
                handleValueChange: this.handleValueChange,
                ref: this.refCallback,
                reset: this.pageRefreshFunction,
                getResults: this.filteredResults
            }

        if (Object.keys(this.props.profile).length > 0) {
            role_access = JSON.parse(this.props.profile.role_access);
            isAdmin = role_access.role === ROLE.ADMIN.toLowerCase();
        }
        let writeAccess = isAdmin || (Object.keys(role_access).length > 0 && role_access.access && role_access.access[ROUTE_ACCESS.NFTCOPY.toLowerCase()].write);

        return (
            <>
                {writeAccess && (
                    <>
                        {this.state.slideModal && <UpdateCopy id={this.state.edit_id} closeEditModal={this.closeModal} />}
                        {this.state.openModal && <ReorderCopies total={this.props.total} copies={this.props.copies} />}
                    </>
                )}

                <div class="content nfts-list">
                    <div class="top-header">
                        <div class="header-title">
                            <h2 class="title">NFTs Copies</h2>
                            <span class="title-caption">You have total {this.props.total} copies.</span>

                            {/*  SEARCH BAR  */}
                            {/* <form class="listing-search-form" onSubmit={(e) => e.preventDefault()}>
                                <span class="search-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17.999" viewBox="0 0 18 17.999">
                                        <path id="search_Icon" data-name="search Icon" d="M9.583,2a7.579,7.579,0,1,0,4.644,13.56l4.159,4.155a.944.944,0,0,0,1.337.011.973.973,0,0,0,0-1.361L15.56,14.228A7.567,7.567,0,0,0,9.583,2Zm0,1.895A5.684,5.684,0,1,1,3.895,9.579,5.684,5.684,0,0,1,9.579,3.895Z" transform="translate(-2 -2)" />
                                    </svg>
                                </span>
                                <input class="form-control" type="search" placeholder="Search in Nft Copies" aria-label="Search" value={this.state.search} onChange={(e) => this.handleSearchChange(e)} />
                            </form> */}
                            {/*  SEARCH BAR END  */}
                        </div>

                        <div class="header-btn">
                            <Filter data={data} classes={filtersArray.filter(arr => arr != "").length > 0 ? "filtered" : ""} />

                            <button class="custom-btn icon-btn dark-btn sm-btn" onClick={this.pageRefreshFunction}>
                                <svg id="refresh" xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
                                    <path id="Path_449" data-name="Path 449" d="M313.164,391.557c-.048-.293-.092-.582-.142-.871a1.127,1.127,0,0,1,.858-1.384,1.064,1.064,0,0,1,1.23.963q.326,1.894.628,3.794a1.1,1.1,0,0,1-.933,1.327l-3.615.643a1.065,1.065,0,0,1-1.262-.888,1.1,1.1,0,0,1,.854-1.288c.438-.095.882-.163,1.378-.252-.108-.068-.173-.113-.242-.151a6.869,6.869,0,0,0-10.015,5.356,7.187,7.187,0,0,0,5.554,8.138,6.961,6.961,0,0,0,8.137-5.977,1.081,1.081,0,0,1,1-.984,1.024,1.024,0,0,1,1.063.8,2.485,2.485,0,0,1-.027.9,9.223,9.223,0,0,1-7.31,7.461,9.074,9.074,0,0,1-10.447-7.421,9.412,9.412,0,0,1,7.2-11.144,8.62,8.62,0,0,1,5.859.9c.053.028.1.056.158.082A.241.241,0,0,0,313.164,391.557Z" transform="translate(-299.689 -389.283)" />
                                </svg>
                                <span class="txt-btn">Refresh</span>
                            </button>

                            {writeAccess &&
                                <>
                                    <button class="custom-btn icon-btn dark-btn sm-btn" data-toggle="modal" data-target="#reorderCopiesModal" onClick={() => this.setState({ openModal: true })}>Reorder Copies</button>
                                    <button class="custom-btn icon-btn dark-btn sm-btn" data-toggle="modal" data-target="#nftSlotHash">Update NFT Slot Hash</button>
                                    <button class="custom-btn gradiant-btn sm-btn" data-toggle="modal" data-target="#releaseNftCopies">Release NFT Copies</button>
                                </>
                            }
                        </div>
                    </div>
                    <div class="main-content">
                        {this.state.error_message &&
                            <Notification
                                type={this.state.error_type}
                                message={this.state.error_message}
                                callback={this.removeNetworkError}
                            />
                        }

                        <div class="copynft-listing table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('id')}>
                                            ID
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'id' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'id' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th scope="col">Name</th>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('code')}>
                                            Code
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'code' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'code' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th scope="col">Owner</th>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('which_bc')}>
                                            Blockchain
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'which_bc' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'which_bc' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('amount')}>
                                            Amount
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'amount' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'amount' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('enable_sale')}>
                                            On Sale
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'enable_sale' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'enable_sale' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th class="tbl-sorting text-center" scope="col" onClick={() => this.sortBy('view_count')}>
                                            View Count
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'view_count' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'view_count' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th class="tbl-sorting text-center" scope="col" onClick={() => this.sortBy('sale_count')}>
                                            Sale Count
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'sale_count' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'sale_count' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('is_released')}>
                                            Released/Unreleased
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'is_released' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'is_released' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th scope="col">Actions</th>
                                    </tr>
                                </thead>

                                {(this.props.total > 0 && !this.props.isLoading) && (
                                    <tbody>
                                        {this.props.copies.map((copy, i) => (
                                            <tr key={i}>
                                                <td scope="row">{copy.id}</td>
                                                <td>{copy.item ? copy.item.name : null}</td>
                                                <td>{copy.code}</td>
                                                <td>{copy.owner ? copy.owner.username === "admin" ? "Terra Virtua" : copy.owner.username : null}</td>
                                                <td>{copy.which_bc ? copy.which_bc === "NAN" ? "" : copy.which_bc : ""}</td>
                                                <td><MoneyField value={copy.amount} /></td>
                                                <td>{copy.enableSale ? 'TRUE' : 'FALSE'}</td>
                                                <td class="text-center">{copy.view_count}</td>
                                                <td class="text-center">{copy.sale_count}</td>
                                                <td className={`${copy.is_released ? 'yes' : 'no'}`}>{copy.is_released ? 'Released' : 'Unreleased'}</td>
                                                <td>
                                                    <div class="action-links">
                                                        <a href={STORE_WEBSITE + 'item/' + copy.code} target="_blank" class="icon view" title="View NFT" data-toggle="tooltip" data-placement="bottom">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                                        </a>
                                                        <a href={this.getMetaMaskLink(copy)} target="_blank" class="icon web-link" title="Blockchain Info" data-toggle="tooltip" data-placement="bottom">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                                <path id="web_link" data-name="web link" d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,2c1.313.006,2.819,3.019,2.977,7.006L9.033,11C9.242,7,10.68,3.994,12,4Zm-3.559.837a15.952,15.952,0,0,0-1.408,6.168L4.059,11A8,8,0,0,1,8.441,4.837Zm7.1-.011a8.039,8.039,0,0,1,4.391,6.187H16.97A15.707,15.707,0,0,0,15.542,4.826ZM4.049,13,7.011,13a16.887,16.887,0,0,0,1.437,6.169A8.129,8.129,0,0,1,4.049,13ZM9,13l5.975-.006C14.758,16.958,13.32,20,12,20S9.225,16.963,9,13Zm7.954,0,2.995-.014a7.969,7.969,0,0,1-4.381,6.158A15.7,15.7,0,0,0,16.958,13Z" transform="translate(-2 -2)" />
                                                            </svg>
                                                        </a>
                                                        {writeAccess && (
                                                            <button class="icon edit" title="Edit NFT Copy" data-toggle="modal" data-target="#editNFTCopies" onClick={(e) => this.openEditModal(e, copy)}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                                    <path id="edit" d="M17,2a1.02,1.02,0,0,0-.719.281l-2,2-8,8A1.02,1.02,0,0,0,6,13v4a1,1,0,0,0,1,1h4a1.02,1.02,0,0,0,.719-.281l8-8,2-2A1.02,1.02,0,0,0,22,7a4.944,4.944,0,0,0-1.281-3.687A4.849,4.849,0,0,0,17,2Zm.375,2.063a2.753,2.753,0,0,1,1.906.625,2.92,2.92,0,0,1,.656,1.937L19,7.563,16.437,5ZM15,6.438,17.562,9l-7,7H8V13.438ZM10,4a1,1,0,0,1,0,2H6A2,2,0,0,0,4,8V18a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V14a1,1,0,0,1,2,0v4a4,4,0,0,1-4,4H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4Z" transform="translate(-2 -2)" />
                                                                </svg>
                                                            </button>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                )}
                            </table>
                        </div>

                        {this.props.total > 0 && (
                            <div class="table-bottom">
                                <div class="dataTables_length">
                                    <label>Show
                                        <select
                                            name="userDataTable_length"
                                            value={this.props.limit}
                                            onChange={(e) => this.handleLimitChange(e.target.value)}
                                        >
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select> of {this.props.total}</label>
                                </div>
                                <Pagination
                                    // hideFirstLastPages
                                    activePage={this.props.page}
                                    itemsCountPerPage={this.props.limit}
                                    totalItemsCount={this.props.total}
                                    pageRangeDisplayed={5}
                                    onChange={this.handlePageChange}
                                    itemClass='page-item'
                                    linkClass='page-link'
                                    prevPageText='Pre'
                                    nextPageText='Next'
                                    firstPageText='First'
                                    lastPageText='Last'
                                    innerClass="dataTables_paginate"
                                    linkClass="paginate_button"
                                    activeLinkClass="paginate_button current"
                                    disabledClass="paginate_button disabled"
                                />
                            </div>
                        )}

                        {(this.props.total < 1 && !this.props.isLoading) && (
                            <div className='table-responsive'>
                                <Notification
                                    type='danger'
                                    message={Helping.getMessageString(
                                        NOT_FOUND,
                                        'NFT Copies '
                                    )}
                                    callback={this.removeNetworkError}
                                />
                            </div>
                        )}
                    </div>
                </div>

                {/* ----- Update NFT Slot Hash ----- */}
                <div class="actionModal modal fade" id="nftSlotHash" tabindex="-1" role="dialog" aria-labelledby="nftSlotHash" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="">Update NFT Slot Hash</h5>
                            </div>

                            <div class="modal-body">
                                <div class="form-group">
                                    <label for="hashVal">Transactions Hash Value: </label>
                                    <input type="text" name="transaction_hash_values" class={`form-control ${this.state.error_transaction_hash_values_message ? 'error-input' : ''}`}
                                        value={this.state.transaction_hash_values} id="hashVal"
                                        onChange={(e) => this.handleInputChange(e)}
                                    />
                                    <span className="error-msg">{this.state.error_transaction_hash_values_message}</span>
                                </div>
                                <div class="form-group mb-0">
                                    <label for="hashSlotLimit">Transactions Hash Slot Limit: </label>

                                    <input type="text" name="transaction_hash_slot_limit"
                                        class={`form-control ${this.state.error_transaction_hash_slot_limit_message ? 'error-input' : ''}`}
                                        value={this.state.transaction_hash_slot_limit} id="hashSlotLimit"
                                        onChange={(e) => this.handleInputChange(e)}
                                    />
                                    <span className="error-msg">{this.state.error_transaction_hash_slot_limit_message}</span>
                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal">Close</button>
                                {this.state.btnIsDisable ?
                                    <LoadingButton class_name={"sm-btn"} />
                                    :
                                    <button class="custom-btn sm-btn gradiant-btn" onClick={(e) => this.submitSlotHashModal(e)}>{this.state.btnIsDisable ? "Loading..." : "Submit"}</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {/* ----- Release NFT Copies Modal */}
                <div class="actionModal modal fade" id="releaseNftCopies" tabindex="-1" role="dialog" aria-labelledby="releaseNftCopies" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="">Release NFT Copies</h5>
                            </div>

                            <div class="modal-body">
                                <div class="form-group">
                                    <label for="nftID">IDs: </label>
                                    <input type="text" name="ids" class={`form-control ${this.state.error_ids_message ? 'error-input' : ''}`} id="nftIDs" value={this.state.ids} onChange={(e) => this.handleInputChange(e)} />
                                    <span className="error-msg">{this.state.error_ids_message}</span>
                                </div>
                                <div class="form-group mb-0">
                                    <label for="relaseTransHash">Release Transactions Hash: </label>
                                    <input type="text" name="release_transaction_hash" class={`form-control ${this.state.error_release_transaction_hash_message ? 'error-input' : ''}`} value={this.state.release_transaction_hash} id="relaseTransHash" onChange={(e) => this.handleInputChange(e)} />
                                    <span className="error-msg">{this.state.error_release_transaction_hash_message}</span>
                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal">Close</button>
                                {this.state.btnIsDisable ?
                                    <LoadingButton class_name={"sm-btn"} />
                                    :
                                    <button class="custom-btn sm-btn gradiant-btn" onClick={(e) => this.submitReleaseNftModal(e)}>{this.state.btnIsDisable ? "Loading..." : "Submit"}</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        copies: state.itemCopies,
        owners: state.owners,
        profile: state.profile,
        total: state.itemCopiesMeta.total,
        isLoading: state.itemCopiesMeta.isLoading,
        page: state.itemCopiesMeta.page,
        limit: state.itemCopiesMeta.limit,
        search: state.itemCopiesMeta.search,
        no_Of_pages: state.itemCopiesMeta.no_Of_pages,
        blockchain: state.itemCopiesMeta.blockchain,
        is_released: state.itemCopiesMeta.is_released,
        enable_sale: state.itemCopiesMeta.enable_sale,
        idFilter: state.itemCopiesMeta.idFilter,
        nameFilter: state.itemCopiesMeta.nameFilter,
        codeFilter: state.itemCopiesMeta.codeFilter,
        owner_id: state.itemCopiesMeta.owner_id,
    };
};

const mapDispatchToProps = {
    getAll,
    update,
    addCurrentRoute,
    destroy
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(List);
